export default {
      id: "common__close-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__close",
      toString: function () {
        return this.url;
      }
    }